import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const BlockTypeIcon = function ({ id, icon, iconSize = 30, className, primaryColor, secondaryColor }) {
  return (icon && id !== 'forest' && id !== 'sunburst')
    ? (
      <FontAwesomeIcon
        style={{ fontSize: iconSize, '--fa-primary-color': primaryColor, '--fa-secondary-color': secondaryColor }}
        className={`${className} ${icon}`}
        icon={icon}
      />
    )
    : <img className={className} src={icon}></img>
}
